module.exports = __webpack_public_path__ + "static/media/address-card.3c6b4f89.svg";